import { setConversationsFetchConfig } from '@homeexchange/conversations';
import { HeFetch } from '@homeexchange/he-fetch';
import i18n from '../i18n';
var heFetch;
export var setHeFetchConfig = function () {
    var heFetchOptions = {
        headers: {
            he_web_version: process.env.VERSION,
            'Accept-Language': i18n.language
        }
    };
    heFetch = new HeFetch(process.env.URL_BFF, heFetchOptions);
    setConversationsFetchConfig(process.env.URL_BFF, heFetchOptions);
};
export { heFetch };
